import addMedia from './addMediaSection';

export { addMedia };
